import SkeletonLoader from '.';

const LessonDetailsSkeleton = () => {
  return (
    <div className="space-y-10 w-full">
      {/* Overview Section */}
      <div className="space-y-4">
        <SkeletonLoader className="h-7 w-32" variant="text" />

        <div className="bg-brand-light-50 rounded-2xl p-6 space-y-6">
          {/* Header */}
          <div className="flex items-center gap-2">
            <SkeletonLoader className="h-8 w-8 rounded-lg" variant="rect" />
            <SkeletonLoader className="h-6 w-48" variant="text" />
          </div>

          {/* Dates & Progress */}
          <div className="space-y-4">
            <div className="flex justify-between">
              <SkeletonLoader className="h-5 w-32" variant="text" />
              <SkeletonLoader className="h-5 w-24" variant="text" />
            </div>
            <div className="flex justify-between">
              <SkeletonLoader className="h-5 w-28" variant="text" />
              <SkeletonLoader className="h-5 w-24" variant="text" />
            </div>
            <div className="space-y-2">
              <div className="flex justify-between">
                <SkeletonLoader className="h-5 w-20" variant="text" />
                <SkeletonLoader className="h-5 w-10" variant="text" />
              </div>
              <SkeletonLoader
                className="h-2 w-full rounded-full"
                variant="rect"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="grid grid-cols-3 gap-6">
        <SkeletonLoader className="h-24 w-full rounded-lg" variant="rect" />
        <SkeletonLoader className="h-24 w-full rounded-lg" variant="rect" />
        <SkeletonLoader className="h-24 w-full rounded-lg" variant="rect" />
      </div>

      {/* Breakdown Section */}
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <SkeletonLoader className="h-7 w-40" variant="text" />
          <SkeletonLoader className="h-5 w-8 rounded-full" variant="rect" />
        </div>

        <div className="space-y-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <div
              key={i}
              className="p-4 rounded-2xl border border-neutral-light-200 flex justify-between items-center"
            >
              <div className="space-y-2">
                <SkeletonLoader className="h-5 w-32" variant="text" />
                <SkeletonLoader className="h-4 w-24" variant="text" />
              </div>
              <div className="flex gap-4">
                <SkeletonLoader
                  className="h-6 w-16 rounded-full"
                  variant="rect"
                />
                <SkeletonLoader className="h-6 w-6 rounded-md" variant="rect" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LessonDetailsSkeleton;
